<template>
  <el-dialog
    class="modal-modify-autoReceive"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content">
      <el-form
        ref="modify"
        :rules="rules"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        class="platform-modify__form"
      >
        <el-form-item label="所属运营商:">
          <el-input
            disabled
            v-model="formData.platformName"
            placeholder="必选, 单选"
            style="width: 291px;"
          ></el-input>
          <el-button v-if="formType !== 'edit'" @click="$_selectPlatform" class="select__btn">选择</el-button>
        </el-form-item>

        <el-form-item label="品牌:">
          <el-input
            type="textarea"
            disabled
            :value="brandNames"
            style="width: 366px; height: 100px;"
            resize="none"
            placeholder="必选, 多选"
          ></el-input>
          <el-button @click="$_selectBrands" class="select__btn">选择</el-button>
        </el-form-item>

        <el-form-item label="备注:" prop="memo" type="textarea">
          <el-input
            type="textarea"
            v-model="formData.memo"
            style="width: 366px; height: 100px;"
            resize="none"
            placeholder="选填"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
    <!-- 选择运营商弹窗组件 -->
    <select-platform
      v-if="modal.show === true && modal.template === 'select-platform'"
      :title="modal.title"
      :selected="modal.data"
      @callback="$_callbackPlatform"
      @close="$_close"
    ></select-platform>
    <!-- 选择品牌弹窗组件 -->
    <select-brands
      v-if="modal.show === true && modal.template === 'select-brands'"
      :title="modal.title"
      :platformKey="formData.platformKey"
      :selecteds="modal.data.brands"
      @callback="$_callbackBrands"
      @close="$_close"
    ></select-brands>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import SelectPlatform from "@/components/modal-select-platform";
import SelectBrands from "@/components/modal-select-brands";

export default {
  name: "modal-modify-autoReceive",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        aid: -1,
        platformKey: "",
        platformName: "",
        brands: [],
        memo: ""
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      rules: {
        brandIdList: [{ required: true, message: "请选择相应品牌" }],
        memo: [
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 50) {
                callback(new Error("最多50个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
        ]
      }
    };
  },
  computed: {
    brandNames() {
      if (this.formData.brands.length > 0) {
        return this.formData.brands.reduce(
          (prev, curr) => prev + (prev ? ", " : "") + curr.brandName,
          ""
        );
      }
      return "";
    },
    brandIdList() {
      if (this.formData.brands.length > 0) {
        return this.formData.brands.reduce(
          (prev, curr) => prev.concat([curr.brandId]),
          []
        );
      }
      return [];
    }
  },
  methods: {
    // 选择运营商
    $_selectPlatform() {
      this.modal.data = {
        platformName: this.formData.platformName,
        platformKey: this.formData.platformKey
      };
      this.modal.title = "选择运营商";
      this.modal.template = "select-platform";
      this.modal.show = true;
    },
    // 选择运营商回调
    $_callbackPlatform(data) {
      let { platformName, platformKey } = data;
      if (platformKey && platformKey !== this.formData.platformKey) {
        this.formData.brands.splice(0);
      }
      this.formData.platformName = platformName;
      this.formData.platformKey = platformKey;
    },
    // 选择品牌
    $_selectBrands() {
      if (this.formData.platformKey === "") {
        $MessageBox.alert({ content: "请选择运营商" });
        return false;
      }
      // 处理已选择的品牌数据
      this.modal.data = {
        brands: this.formData.brands.concat([]),
        brandIdList: this.brandIdList.concat([])
      };
      this.modal.title = "选择品牌";
      this.modal.template = "select-brands";
      this.modal.show = true;
    },
    // 选择品牌回调
    $_callbackBrands(data) {
      this.formData.brands = data.concat([]);
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
    $_submit() {
			if (this.formData.platformKey === "") {
				$MessageBox.alert({content: '请选择所属运营商'});
				return false;
			}
			if (this.formData.brands.length < 1) {
				$MessageBox.alert({content: '请选择品牌'});
				return false;
			}
      this.$refs["modify"].validate(valid => {
        if (valid) {
          const self = this;
          self.isLoading = true;
          let action = "addAutomaticOrder";
          let postData = {
            brandIds: self.brandIdList,
            memo: self.formData.memo
          };
          if (self.formType === "edit") {
            action = "editAutomaticOrder";
            Object.assign(postData, {
              aid: self.formData.aid
            });
          } else {
						Object.assign(postData, {
							platformKey: self.formData.platformKey,
						})
					}
          self.$service.post(action, postData).then(result => {
            self.isLoading = false;
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.visible = false;
                  self.$emit("callback");
                }
              });
            }
          });
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created() {
    if (this.formType === "edit") {
      let {
        aid,
        platformKey,
        platformName,
        brandIds,
        brandNames,
        memo
			} = this.modalData;
      // let brandIdArr = brandIds.split(",");
      let brandNameArr = brandNames.split(",");
      let brands = [];
      brandIds.forEach((item, index) => {
        brands.push({
					platformName,
					platformKey,
          brandId: item,
          brandName: brandNameArr[index]
        });
			});
      this.formData.aid = aid;
      this.formData.platformName = platformName;
      this.formData.platformKey = platformKey;
      this.formData.brands = brands.concat([]);
      this.formData.memo = memo || '';
    }
  },
  mounted() {
    this.visible = true;
  },
  components: {
    SelectBrands,
    SelectPlatform
  }
};
</script>

<style lang="scss" scoped>
.platform-modify__form {
  padding: {
    left: 20px;
  }
}
.content {
  padding: 20px 20px;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.select__btn {
  margin-left: 8px;
  vertical-align: top;
}
.type__chk {
  margin: {
    top: 5px;
    right: 64px;
  }
}
.input-tips{
  margin-left:10px;
}
</style>


